import React from 'react';
import { Table, Button, Icon } from 'semantic-ui-react';

const HeadMealTable = React.memo(({ addDish, isRedHead }) => {
  const classNameHeadCell = isRedHead ? 'menu-table-red-head' : '';
  return (
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell textAlign="center" width="4" className={classNameHeadCell}>
          <Button onClick={addDish} color="green" icon size="mini">
            <Icon name="add" />
          </Button>
          Блюдо
        </Table.HeaderCell>
        <Table.HeaderCell className={classNameHeadCell} textAlign="center" width="1">
          К
        </Table.HeaderCell>
        <Table.HeaderCell className={classNameHeadCell} textAlign="center" width="1">
          Б
        </Table.HeaderCell>
        <Table.HeaderCell className={classNameHeadCell} textAlign="center" width="1">
          Ж
        </Table.HeaderCell>
        <Table.HeaderCell className={classNameHeadCell} textAlign="center" width="1">
          У
        </Table.HeaderCell>
        <Table.HeaderCell className={classNameHeadCell} textAlign="center" width="2">
          Порция/грамм
        </Table.HeaderCell>
        <Table.HeaderCell className={classNameHeadCell} textAlign="center" width="2">
          Время приема
        </Table.HeaderCell>
        <Table.HeaderCell className={classNameHeadCell} textAlign="center" width="1">
          Удалить
        </Table.HeaderCell>
      </Table.Row>
    </Table.Header>
  );
});

export default HeadMealTable;



// WEBPACK FOOTER //
// ./src/Components/Common/MenuBlock/HeadMealTable.jsx